import type { CSSProperties, ReactNode } from 'react';

export type BadgeTone = 'neutral' | 'brand' | 'success' | 'warning' | 'danger' | 'info';

const tones: Record<BadgeTone, { bg: string; fg: string; dot: string }> = {
    neutral: { bg: 'var(--surface-secondary)', fg: 'var(--neutral-700)', dot: 'var(--neutral-500)' },
    brand: { bg: 'var(--surface-brand-soft)', fg: 'var(--text-brand)', dot: 'var(--burgundy-500)' },
    success: { bg: 'var(--success-soft)', fg: 'var(--success-strong)', dot: 'var(--success)' },
    warning: { bg: 'var(--warning-soft)', fg: 'var(--warning-strong)', dot: 'var(--warning)' },
    danger: { bg: 'var(--danger-soft)', fg: 'var(--danger-strong)', dot: 'var(--danger)' },
    info: { bg: 'var(--info-soft)', fg: 'var(--info-strong)', dot: 'var(--info)' },
};

export interface BadgeProps {
    tone?: BadgeTone;
    /** Ponto colorido antes do texto, para status. */
    dot?: boolean;
    children?: ReactNode;
    style?: CSSProperties;
}

export function Badge({ tone = 'neutral', dot = false, children, style }: BadgeProps) {
    const t = tones[tone] ?? tones.neutral;
    return (
        <span
            style={{
                display: 'inline-flex', alignItems: 'center', gap: 6, height: 22, padding: '0 9px',
                borderRadius: 'var(--radius-pill)', background: t.bg, color: t.fg,
                fontFamily: 'var(--font-ui)', fontSize: 12, fontWeight: 500, lineHeight: '16px',
                whiteSpace: 'nowrap', ...style,
            }}
        >
            {dot && <span style={{ width: 6, height: 6, borderRadius: '50%', background: t.dot }} />}
            {children}
        </span>
    );
}
